import Ajv, { JSONSchemaType }  from 'ajv'
import addFormats from 'ajv-formats'

const ajv = new Ajv({ allErrors: true, useDefaults: true, allowUnionTypes: true })
addFormats(ajv)

export type T<Value> = Schema<Value>

type Schema<Value> = JSONSchemaType<Value>

type Parser<Value> = (value:unknown)=> Value

export const parserFor = <Value>(schema:Schema<Value>): Parser<Value> => {
  const validateWithAjv = ajv.compile<Value>(schema)
  return (value) => {
    if (validateWithAjv(value)) {
      return value
    } else {
      throw Error(validateWithAjv.errors
        ? validateWithAjv.errors.map(error => createErrorMessage(error)).join('\n')
        : 'parsing error')
    }
  }
}
export const parserForCollection = <Value>(schema:Schema<Value[]>, schemeName: string): Parser<Value[]> => {
  const validateCollectionWithAjv = ajv.compile<Value[]>(schema)
  const validateItemWithAjv = ajv.compile<Value>(schema.items)
  return (value) => {
    if (validateCollectionWithAjv(value)) {
      return value
    } else {
      if(!value || !Array.isArray(value)) throw Error(validateCollectionWithAjv.errors
        ? validateCollectionWithAjv.errors.map(error => createErrorMessage(error)).join('\n')
        : 'parsing error')

      return value.reduce((acc, item) => {
        if(validateItemWithAjv(item)) {
          acc.push(item)
        } else {
          validateItemWithAjv.errors
            ? validateItemWithAjv.errors
              .forEach(error => console.error(`parsing error with ${schemeName} item`, { item, error, message: createErrorMessage(error) }))
            : console.error(`parsing error with ${schemeName} item`, item)
        }
        return acc
      }, [])

    }
  }
}
const createErrorMessage = ({ instancePath, message = 'unknown error', data = undefined }: {instancePath: string, message?: string, data?: unknown}): string =>
  `${instancePath} ${message}, got ${data}`
